<template>
    <div class="pay-select">
        <div class="pay-item" @click="itemClick(1)" :class="{active:current===1}">
            <img class="pay-item-img" src="./../assets/img/zf.png" alt="">
            <div class="pay-item-name">支付宝支付</div>
            <img v-if="current===1" class="pay-item-select" src="./../assets/img/ch1.png" alt="">
            <img v-else class="pay-item-select" src="./../assets/img/ch.png" alt="">
        </div>
        <div class="pay-item" @click="itemClick(2)" :class="{active:current===2}">
            <img class="pay-item-img" src="./../assets/img/wxp.png" alt="">
            <div class="pay-item-name">微信支付</div>
            <img v-if="current===2" class="pay-item-select" src="./../assets/img/ch1.png" alt="">
            <img v-else class="pay-item-select" src="./../assets/img/ch.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: "PaySelect",
        data() {
            return {
                current: ''
            }
        },
        methods: {
            itemClick(index) {
                this.current = index;
                this.$emit('change', index)
            }
        },
    }
</script>

<style scoped lang="less">
    .pay-select{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .pay-item{
            width: 160px;
            height: 50px;
            border: 1px solid #e2e2e2;
            margin: 20px;
            margin-left: 0;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            .pay-item-img{
                width: 30px;
                height: 30px;
                object-fit: contain;
            }
            .pay-item-name{
                margin-left: 10px;
                font-size: 14px;
            }
            .pay-item-select{
                position: absolute;
                bottom: 0;
                right: 0;
            }
        }
    }
    .active{
        border-color: #e44646 !important;
    }
</style>
